import { LOCALE, ISO_LOCALE } from "../interfaces";

export const LOCALES = [
	{
		code: LOCALE.ENGLISH,
		iso: ISO_LOCALE.ENGLISH
	},
	{
		code: LOCALE.UKRAINIAN,
		iso: ISO_LOCALE.UKRAINIAN
	}
]